import React, {PureComponent} from "react"

import intercom from "@irati/utils/intercom"
import FormattedMessage from "@irati/utils/lang"
import {TenantOnboardingStepStates} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"

import {Footer} from "./styled"
import {SetupSteps} from "../../constants/stepConfig"
import {TENANT_SETUP_TOUR_PREFIX} from "../../tour"

interface Props {
  stepId: string,
  completable: boolean,
  state: TenantOnboardingStepStates,
  handleNextStep: () => void,
  handleSkip: () => void,
  handleMarkComplete: () => void
}

class CompleteStepFooter extends PureComponent<Props> {
  // Ensure the intercom help bubble is never shown over the footer
  componentWillMount = () => intercom.hide()
  componentWillUnmount = () => intercom.show()

  render() {
    const {state, handleSkip, handleMarkComplete, handleNextStep, completable, stepId} = this.props
    const isStepDone = state === TenantOnboardingStepStates.Done
    const isStepSkipped = state === TenantOnboardingStepStates.Skipped
    const isInviteStep = stepId === SetupSteps.INVITE || stepId === SetupSteps.SETUP_SSO

    const skipStepHandler = isStepDone || isStepSkipped ? handleNextStep : handleSkip
    const skipStepKey = isStepDone || isStepSkipped ? "setup_tenant.footer.nextStep" : "setup_tenant.footer.skipStep"

    if (isInviteStep) {
      return (
        <Footer>
          <Flex alignItems="center" justifyContent="flex-end">
            <Button primary inverted data-tour={`${TENANT_SETUP_TOUR_PREFIX}step02`} disabled={!completable} onClick={handleMarkComplete}>
              <FormattedMessage id="setup_tenant.footer.finishSetup" />
            </Button>
          </Flex>
        </Footer>
      )
    }

    return (
      <Footer>
        <Flex data-tour={`${TENANT_SETUP_TOUR_PREFIX}step02`} alignItems="center" justifyContent="flex-end">
          {/* Skip Step Button */}
          <Button onClick={skipStepHandler} primary={isStepDone} inverted marginRight={2}>
            <FormattedMessage id={skipStepKey} />
          </Button>

          {/* Complete Step Button */}
          {!isStepDone && (
            <Button disabled={!completable} onClick={handleMarkComplete} primary inverted marginRight={2}>
              <FormattedMessage id="setup_tenant.footer.markComplete" />
            </Button>
          )}
        </Flex>
      </Footer>
    )
  }
}

export default CompleteStepFooter
